import { render, staticRenderFns } from "./cookie-script-request-new-consents-modal.vue?vue&type=template&id=c16dc2da"
import script from "./cookie-script-request-new-consents-modal.vue?vue&type=script&lang=js"
export * from "./cookie-script-request-new-consents-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports